import { render } from "./RejectionModal.vue?vue&type=template&id=5f8a5a71&scoped=true"
import script from "./RejectionModal.vue?vue&type=script&lang=js"
export * from "./RejectionModal.vue?vue&type=script&lang=js"

import "./RejectionModal.vue?vue&type=style&index=0&id=5f8a5a71&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8a5a71"]])

export default __exports__